// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import './style/index.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VideoPlayer from 'vue-video-player'
import request from '@/utils/request'
import store from './store'
import ba from 'vue-ba'
import VueMatomo from 'vue-matomo'
// import qrcode from 'vue-qrcode-directive'
// Vue.use(qrcode)
// import axios from 'axios'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(ElementUI, VideoPlayer)

Vue.config.productionTip = false
Vue.prototype.$http = request

Vue.use(ba, '3d0be6625280ab638759771e68be01b4')
Vue.use(ba, { siteId: '3d0be6625280ab638759771e68be01b4' })

Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://t.kongbaidata.com',
  siteId: 2,
  trackerFileName: 'matomo',
  router: router,
  enableLinkTracking: true,
  requireConsent: false,
  trackInitialView: true,
  disableCookies: false,
  enableHeartBeatTimer: false,
  heartBeatTimerInterval: 15,
  debug: false,
  userId: undefined,
  cookieDomain: undefined,
  domains: undefined,
  preInitActions: []
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js